export default __webpack_public_path__ + "static/media/dhan-ki-devi.5eead019.webp";